import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ModelResponse } from '../../core/services/ModelResponse';

@Injectable()
export class PermissionService {
  constructor(public httpClient: HttpClient) {

  }

  getCurrentUserPermissions(): Observable<ModelResponse<string[]>> {
    return this.httpClient.get<ModelResponse<string[]>>("/api/SecurityModule/CurrentUserPermissions/List");
  }
}



// WEBPACK FOOTER //
// ./src/app/security/services/PermissionService.ts